function generateDetailedArc(
  { x0, x1, y0, y1 }: { x0: number; y0: number; x1: number; y1: number },
  steps = 50,
): { topFrames: number[]; leftFrames: number[] } {
  const xm = (x0 + x1) / 2;
  const ym = Math.min(y0, y1);

  const topFrames: number[] = [];
  const leftFrames: number[] = [];

  for (let i = 0; i <= steps; i++) {
    const t = i / steps;

    const x = (1 - t) ** 2 * x0 + 2 * (1 - t) * t * xm + t ** 2 * x1;
    const y = (1 - t) ** 2 * y0 + 2 * (1 - t) * t * ym + t ** 2 * y1;

    topFrames.push(y);
    leftFrames.push(x);
  }

  return { topFrames, leftFrames };
}

export { generateDetailedArc };
